import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Log } from "ng2-logger";
import { ModalComponent } from "@app/shared/components";
import { ToolDetails } from "@app/tool/model/toolDetails.model";
import { FormType } from "@app/tool/details/components/form-type.enum";
import * as _ from "lodash";
import {
    SpecialIdentifiersFormComponent
} from "@app/tool/details/components/forms/special-identifiers-form/special-identifiers-form.component";

@Component({
    selector: 'app-special-identifiers-form-modal',
    templateUrl: './special-identifiers-form-modal.component.html',
    styleUrls: ['./special-identifiers-form-modal.component.scss']
})
export class SpecialIdentifiersFormModalComponent implements OnInit {

    _logger = Log.create(SpecialIdentifiersFormModalComponent.name);

    @ViewChild(ModalComponent, {static: false}) modal: ModalComponent;
    @ViewChild(SpecialIdentifiersFormComponent, {static: false}) specialIdentifiersForm: SpecialIdentifiersFormComponent;

    @Input() toolDetails: ToolDetails;
    @Input() isLoading = false;
    @Output() updateSpecialIdentifiers = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    open() {
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    clickUpdate() {
        const lifecycle = this.specialIdentifiersForm.value();

        this.updateSpecialIdentifiers.emit({
            type: FormType.SPECIAL_IDENTIFIERS,
            specialIdentifiers: _(lifecycle).omitBy(_.isNil).omitBy(_.isNaN).value()
        });
    }
}
